<ng-template #empty>
  <em class="value text-cloud-500"><small>-- none --</small></em>
</ng-template>
<ng-template #invalidLink let-link="link" let-img="img">
  <div class="value">
    <p class="d-inline-block mb-0 mr-2">{{ link }}</p>
    <p class="d-inline-block mb-0 text-cloud-600"
      ><small
        ><em>
          Use a complete URL (beginning with <code>https://</code>)
          {{ img ? 'to render this as an image' : 'to make this a hyperlink' }}.</em
        ></small
      ></p
    >
  </div>
</ng-template>

<div class="row lum-c-rfq-details-page" *ngIf="rfq && rfq.id">
  <div class="col-xl-6 col-sm-8">
    <div class="form-group mb-3">
      <small class="label">Product Description</small>
      <span
        *ngIf="rfq.product_description; else empty"
        class="value"
        [innerHTML]="sanitizer.bypassSecurityTrustHtml(rfq.product_description)"
      ></span>
    </div>
    <div class="form-group mb-3">
      <small class="label">Product Design Link</small>
      <a
        *ngIf="hasValidDesignLink; else invalidDesignLink"
        class="value"
        [href]="rfq.product_design[0]"
        target="_blank"
      >
        {{ rfq.product_design[0] }}
        <sup><i class="fas fa-external-link-alt fa-xs"></i></sup>
      </a>
      <ng-template #invalidDesignLink>
        <ng-container
          *ngIf="rfq.product_design?.[0]; else empty"
          [ngTemplateOutlet]="invalidLink"
          [ngTemplateOutletContext]="{ link: rfq.product_design?.[0] ?? '' }"
        ></ng-container>
      </ng-template>
    </div>
  </div>
  <div class="col-lg-2 col-md-3 col-sm-4 lum-c-rfq-details-page__product-image">
    <div class="form-group mb-3">
      <small class="label">Product Image</small>
      <a
        *ngIf="hasValidPhoto; else invalidPhoto"
        class="value"
        [href]="rfq.photo[0]"
        target="_blank"
      >
        <img [src]="rfq.photo[0]" [alt]="rfq.product_name" />
      </a>
      <ng-template #invalidPhoto>
        <ng-container
          *ngIf="rfq.photo?.[0]; else empty"
          [ngTemplateOutlet]="invalidLink"
          [ngTemplateOutletContext]="{ link: rfq.photo?.[0] ?? '', img: true }"
        ></ng-container>
      </ng-template>
    </div>
  </div>

  <div class="col-md-6">
    <div class="row">
      <div class="col-6 col-md-4">
        <div class="form-group">
          <small class="label"
            >SKU ({{ rfq.variant_parent_id > 0 ? 'Variant' : 'Master' }})</small
          >
          <span class="value">{{ rfq.internal_sku }}</span>
        </div>
      </div>
      <div class="col-6 col-md-4">
        <div class="form-group">
          <small class="label">UPC</small>
          <span *ngIf="rfq.upc; else empty" class="value">{{ rfq.upc }}</span>
        </div>
      </div>
    </div>

    <div class="form-group" *ngIf="rfq.category">
      <small class="label" [translate]="'LABELS.PRODUCT_CATEGORY'"
        >Product Category</small
      >
      <span class="value">{{ rfq.category.product_category }}</span>
    </div>

    <div
      class="form-group"
      *ngIf="featureFlag.REMOVE_PRODUCT_DEPARTMENT | featureFlag"
    >
      <small class="label">Product Department</small>
      <span class="value">{{ rfq.product_dept }}</span>
    </div>

    <div class="row" *ngIf="rfq.product_type_id != 3">
      <div class="col-6 col-md-4">
        <div class="form-group">
          <small class="label">Re-Order Level</small>
          <span
            class="value"
            [ngClass]="{
              'text-danger font-500':
                rfq.reorder_level > 0 &&
                rfq.stock &&
                rfq.stock.qty_onhand - rfq.stock.qty_onhand <= rfq.reorder_level,
            }"
            >{{ rfq.reorder_level }}</span
          >
        </div>
      </div>
      <div class="col-6 col-md-4">
        <div class="form-group">
          <small class="label">Low Stock Alert Quantity</small>
          <span
            class="value"
            [ngClass]="{
              'text-danger font-500':
                rfq.qty_limit_notify > 0 &&
                rfq.stock &&
                rfq.stock.qty_onhand - rfq.stock.qty_onhand <= rfq.qty_limit_notify,
            }"
            >{{ rfq.qty_limit_notify }}</span
          >
        </div>
      </div>
      <div class="col-6 col-md-4">
        <div class="form-group">
          <small class="label">Minimum Stock</small>
          <span
            class="value"
            [ngClass]="{
              'text-danger font-500':
                rfq.oss_limit_notify > 0 &&
                rfq.stock &&
                rfq.stock.qty_onhand - rfq.stock.qty_onhand <= rfq.oss_limit_notify,
            }"
            >{{ rfq.oss_limit_notify }}</span
          >
        </div>
      </div>

      <ng-container *ngIf="rfq.product_type_id != 3">
        <div class="col-6 col-md-4">
          <div class="form-group">
            <small class="label">Wholesale Price</small>
            <span class="value">{{ rfq.wholesale_price | currency: '' }}</span>
          </div>
        </div>
        <div class="col-6 col-md-4">
          <div class="form-group">
            <small class="label">Retail Price</small>
            <span class="value">{{ rfq.retail_price | currency: '' }}</span>
          </div>
        </div>
        <div class="col-6 col-md-4" *ngxPermissionsOnly="'skuUnitCost.read'">
          <div class="form-group">
            <small class="label">Unit Cost</small>
            <span class="value">{{
              (rfq.base_price ? rfq.base_price.weighted : 0) | decimalPlaces
            }}</span>
          </div>
        </div>
      </ng-container>
    </div>

    <div class="row" *ngIf="rfq.type === productTypes.PRODUCT">
      <div class="col-6 col-md-4">
        <div class="form-group">
          <small class="label">Unit Class</small>
          <span class="value">{{ rfq.unit_class ? rfq.unit_class.name : '' }}</span>
        </div>
      </div>
      <div class="col-6 col-md-4">
        <div class="form-group">
          <small class="label">Default Selling Unit</small>
          <span class="value">{{
            rfq.default_selling_unit ? rfq.default_selling_unit.name : ''
          }}</span>
        </div>
      </div>
      <div class="col-6 col-md-4" *ngIf="UserPermission.can('viewUnitCost')">
        <div class="form-group">
          <small class="label">Default Purchase unit</small>
          <span class="value">{{
            rfq.default_purchase_unit ? rfq.default_purchase_unit.name : ''
          }}</span>
        </div>
      </div>
      <div class="col-6 col-md-4">
        <div class="form-group">
          <small class="label">Default Receiving Bin</small>
          <span class="value">{{
            rfq.default_receiving_bin ? rfq.default_receiving_bin.location_name : ''
          }}</span>
        </div>
      </div>
    </div>

    <div class="row" *ngIf="rfq.variant_parent_id > 0">
      <div class="col-md-12">
        <div class="form-group">
          <small class="label">Inventory Tracking</small>
          <span class="text-warning" *ngIf="rfq.mirror_inventory_from_parent == 1"
            >This SKU mirrors inventory from parent master SKU</span
          >
          <span class="text-danger" *ngIf="!rfq.mirror_inventory_from_parent"
            >This SKU tracks own inventory</span
          >
        </div>
      </div>
    </div>

    <div class="form-group" *ngIf="rfq.product_link && rfq.product_link.length > 0">
      <small class="label">
        <span [translate]="'TEXT.PD_PRODUCT_LISTINGS'">Product Listings</span>
        <ng-container *ngIf="productLinks?.length > 0">
          (<button
            type="button"
            class="lum-u-reset"
            (click)="showProductLinks = !showProductLinks"
            >{{ showProductLinks ? 'Hide' : 'Show' }}</button
          >)
        </ng-container>
      </small>
      <ng-container *ngIf="productLinks?.length > 0; else empty">
        <ng-container *ngIf="showProductLinks">
          <span class="value" *ngFor="let link of productLinks">
            <a href="{{ link.lv }}" target="_blank">
              {{ link.lv }}
              <sup><i class="fas fa-external-link-alt fa-xs"></i></sup>
            </a>
          </span>
        </ng-container>
      </ng-container>
    </div>
    <div
      class="form-group"
      *ngFeatureFlag="featureFlag.CUSTOM_FIELDS; isDisabled: false"
    >
      <small class="label">Custom Fields</small>
      <lum-custom-field-value-details
        *ngIf="rfq?.custom_field_values?.length > 0; else empty"
        [customFieldValues]="rfq?.custom_field_values || []"
      ></lum-custom-field-value-details>
    </div>

    <div *ngIf="materials?.length > 0" class="form-group">
      <small class="label">Product Materials</small>
      <ul>
        <li *ngFor="let material of materials" class="value">
          {{ material.mv }}
        </li>
      </ul>
    </div>

    <!--         <div class="form-group" *ngIf="rfq.photo">
            <small class="label">Product Photo</small>
            <span class="value" *ngFor="let pht of rfq.photo">
                <a href="{{pht}}" target="_blank">
                    View Photo
                </a>
            </span>
        </div>

        <div class="form-group" *ngIf="rfq.product_design">
            <small class="label">Product Design</small>
            <span class="value" *ngFor="let design of rfq.product_design">
                <a href="{{design}}" target="_blank">
                    View Product Design
                </a>
            </span>
        </div> -->

    <div class="form-group" *ngIf="rfq.is_product_in_market == 4">
      <small class="label" [translate]="'TEXT.PD_PRODUCT_ON_MARKET'">
        Does product exist on marketplace</small
      >
      <span class="value" [translate]="'TEXT.PD_MINOR_CHANGES'">
        Similar but will make minor changes</span
      >
    </div>

    <div class="form-group" *ngIf="rfq.is_product_in_market == 4">
      <small class="label" [translate]="'TEXT.PD_CHANGES_TO_MAKE'"
        >Changes to make</small
      >
      <span class="value">{{ rfq.changes_to_make }}</span>
    </div>

    <ng-container *ngIf="featureFlag.ASSEMBLY_ORDER | featureFlag">
      <hr />
      <section>
        <h5>
          Bill of Materials
          <a
            href="javascript:;"
            class="ml-2"
            (click)="assignBillOfMaterials()"
            *ngIf="authService.loginUser.role !== userRoleConstants.SALES_MEMBER"
          >
            <i class="fas fa-edit"></i>
          </a>
        </h5>
        <span
          class="
            alternate-sku kt-badge kt-badge--primary kt-badge--outline kt-badge--pill
          "
          *ngFor="let bomRfq of rfq.bom_rfqs; let i = index; trackBy: trackByValue"
        >
          {{ bomRfq?.bom?.name
          }}<a
            href="javascript:void(0);"
            class="text-danger"
            (click)="detachBillOfMaterials(i)"
          >
            <i class="fa fa-fw fa-times ml-1"></i>
          </a>
        </span>
      </section>
    </ng-container>

    <hr />

    <section>
      <h5>
        Alternate SKUs
        <a
          href="javascript:;"
          class="ml-2"
          (click)="updateAlternateSkus()"
          *ngIf="authService.loginUser.role != 2"
        >
          <i class="fas fa-edit"></i>
        </a>
      </h5>
      <span
        class="
          alternate-sku kt-badge kt-badge--primary kt-badge--outline kt-badge--pill
        "
        *ngFor="let sku of rfq.alternate_skus"
      >
        {{ sku.alternate_sku }}
      </span>
    </section>

    <hr />

    <section>
      <h5>
        Master SKUs as Alternate SKUs
        <a
          href="javascript:;"
          class="ml-2"
          (click)="updateAlternateMasterSkus()"
          *ngIf="authService.loginUser.role != 2"
        >
          <i class="fas fa-edit"></i>
        </a>
      </h5>
      <span
        class="
          alternate-sku kt-badge kt-badge--primary kt-badge--outline kt-badge--pill
        "
        *ngFor="let sku of rfq.childSku"
      >
        {{ sku.internal_sku }}
      </span>
    </section>

    <hr />

    <section>
      <h5 [translate]="'TITLES.PRODUCT_VARIANTS'">
        Product Variants
        <a
          href="javascript:;"
          class="ml-2"
          (click)="editVariants()"
          *ngIf="authService.loginUser.role != 2"
        >
          <i class="fas fa-edit"></i>
        </a>
      </h5>

      <ng-container *ngIf="rfq.variant_parent_id > 0">
        <div
          class="form-group variants"
          *ngFor="let variant of variants; let i = index"
        >
          <div
            *ngIf="
              variant.variant_terms && selectedVariantTerms[variant.variant_name]
            "
          >
            <span class="name"> {{ variant.variant_name }}</span>
            <span class="terms">{{
              selectedVariantTerms[variant.variant_name]
            }}</span>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="rfq.variant_parent_id === 0">
        <div
          class="form-group variants"
          *ngFor="let variant of rfq.product_variants"
        >
          <div *ngIf="variant.variant_terms">
            <span class="name">{{ variant.variant_name }}</span>
            <span class="terms">{{ variant.variant_terms }}</span>
          </div>
        </div>
      </ng-container>
    </section>

    <hr />

    <section>
      <h5>Product Tags</h5>
      <div class="form-group tags" *ngFor="let tag of rfq.tags">
        <span class="name">{{ tag.tag_details.name }}</span>
      </div>
    </section>

    <hr />

    <div
      class="form-group checklist"
      *ngIf="rfq.brand_product == 2"
      [translate]="'TEXT.PD_BRAND_PRODUCT'"
    >
      <i class="fas fa-check text-success"></i> Want to brand this product (logos,
      tags, labels, etc)
    </div>
    <div
      class="form-group checklist"
      *ngIf="rfq.artwork_available == 2"
      [translate]="'TEXT.PD_ART_AVAILABLE'"
    >
      <i class="fas fa-check text-success"></i> Art available as attached
    </div>
    <section>
      <h5 [translate]="'TITLES.PRODUCT_ATTACHMENTS'"> Product Attachments </h5>
      <cnc-attachments-view
        [attachments]="rfq.rfq_attachments"
      ></cnc-attachments-view>
      <ul class="m-0">
        <li *ngFor="let file of rfq.rfq_attachments; let i = index">
          <a href="{{ url + '/file?f=' + file.filename }}" target="_blank">
            {{ file.remarks ? file.remarks : 'File ' + (i + 1) }}
          </a>
        </li>
      </ul>
    </section>

    <hr />

    <section>
      <h5>
        B2B Client Portal Images
        <a
          href="javascript:void(0);"
          (click)="addImage(rfq.id)"
          class="ml-2"
          *ngIf="authService.loginUser.role != 2"
        >
          <i class="fas fa-edit"></i>
        </a>
      </h5>
      <div class="row">
        <div class="col-12">
          <a
            class="m-2"
            href="javascript:void(0);"
            (click)="viewImage(image.id, rfq.id)"
            *ngFor="let image of rfq.images"
          >
            <img src="{{ image.thumbnail_url }}" alt="" class="img-thumbnail" />
          </a>
        </div>
      </div>
    </section>
  </div>

  <div class="col-md-6">
    <div class="form-group">
      <small class="label">Locations</small>

      <div *ngIf="rfq.location_stocks?.length > 0">
        <cnc-rfq-stock-locations
          [locationStocks]="rfq.location_stocks | transformKeys: 'snakeToCamel'"
        ></cnc-rfq-stock-locations>
      </div>
    </div>

    <div class="shipping-details">
      <section class="my-4">
        <h5 [translate]="'TITLES.PACKAGING_DETAILS'"> Packaging Details </h5>

        <h6 class="mt-3">Product</h6>
        <dl class="dl-grid dl-dt-weight-normal gap-x-3 ml-3">
          <div class="form-group">
            <dt>Weight:</dt>
            <dd>
              <span *ngFor="let weight of rfq?.product_weight ?? []">
                {{ weight.wv }} {{ weight.mu }}
              </span>
            </dd>
          </div>
          <div class="form-group">
            <dt>Dimensions (L &times; W &times; H):</dt>
            <dd>
              <span>{{ rfq.product_length }}</span> &times;
              <span>{{ rfq.product_width }}</span> &times;
              <span>{{ rfq.product_height }}</span> in
            </dd>
          </div>
        </dl>

        <h6 class="mt-3">Shipping</h6>
        <dl class="dl-grid dl-dt-weight-normal gap-x-3 ml-3">
          <div class="form-group">
            <dt>Weight:</dt>
            <dd>
              <span *ngFor="let weight of rfq.shipping_weight">
                {{ weight.wv }} {{ weight.mu }}
              </span>
            </dd>
          </div>
          <div class="form-group">
            <dt>Dimensions (L &times; W &times; H):</dt>
            <dd>
              <span>{{ rfq.shipping_length }}</span> &times;
              <span>{{ rfq.shipping_width }}</span> &times;
              <span>{{ rfq.shipping_height }}</span> in
            </dd>
          </div>
        </dl>

        <h6 class="mt-3">Box</h6>
        <dl class="dl-grid dl-dt-weight-normal gap-x-3 ml-3">
          <div class="form-group">
            <dt>Weight:</dt>
            <dd>
              <span *ngFor="let weight of rfq.box_weight">
                {{ weight.wv }} {{ weight.mu }}
              </span>
            </dd>
          </div>
          <div class="form-group">
            <dt>Dimensions (L &times; W &times; H):</dt>
            <dd>
              <span>{{ rfq.box_length }}</span> &times;
              <span>{{ rfq.box_width }}</span> &times;
              <span>{{ rfq.box_height }}</span> in
            </dd>
          </div>
        </dl>

        <h6 class="mt-3">Carton</h6>
        <dl class="dl-grid dl-dt-weight-normal gap-x-3 ml-3">
          <div class="form-group">
            <dt>Weight:</dt>
            <dd>
              <span *ngFor="let weight of rfq.carton_weight">
                {{ weight.wv }} {{ weight.mu }}
              </span>
            </dd>
          </div>
          <div class="form-group">
            <dt>Dimensions (L &times; W &times; H):</dt>
            <dd>
              <span>{{ rfq.carton_length }}</span> &times;
              <span>{{ rfq.carton_width }}</span> &times;
              <span>{{ rfq.carton_height }}</span> in
            </dd>
          </div>
        </dl>

        <h6 class="mt-3">Pallet</h6>
        <dl class="dl-grid dl-dt-weight-normal gap-x-3 ml-3">
          <div class="form-group">
            <dt>Weight:</dt>
            <dd>
              <span *ngFor="let weight of rfq.pallet_weight">
                {{ weight.wv }} {{ weight.mu }}
              </span>
            </dd>
          </div>
          <div class="form-group">
            <dt>Dimensions (L &times; W &times; H):</dt>
            <dd>
              <span>{{ rfq.pallet_length }}</span> &times;
              <span>{{ rfq.pallet_width }}</span> &times;
              <span>{{ rfq.pallet_height }}</span> in
            </dd>
          </div>
        </dl>

        <div class="form-group" *ngIf="rfq.is_palletized">
          Product is palletized
        </div>

        <dl class="dl-grid dl-dt-weight-normal gap-x-3">
          <div class="form-group">
            <dt>Cartons per pallet:</dt>
            <dd>{{ rfq.cartons_per_pallet }}</dd>
          </div>

          <div class="form-group">
            <dt>Units per carton:</dt>
            <dd>{{ rfq.units_per_carton }}</dd>
          </div>

          <div class="form-group form-inline">
            <dt>Units per pallet:</dt>
            <dd>{{ rfq.units_per_pallet }}</dd>
          </div>
        </dl>
      </section>
    </div>
  </div>
</div>
